export default {
  tipos: [],
  prazos: [],
  veiculos: [],
  tipo: ""
}
